import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';
import * as i18next from 'i18next';
import * as api from 'core/api';
import * as utils from 'core/utils';
import * as flights from 'core/flights';
import { PassengerModel } from 'core/flights';


// eslint-disable-next-line @typescript-eslint/no-var-requires
const WithRender = require('./template.html');

@WithRender
@Component
export class AdditionalBaggageComponent extends Vue {
    @Prop()
    reservation: flights.ReservationModel;

    @Prop()
    flightBookingDetails: api.FlightBookingDetails;
    
    @Prop()
    flight: flights.FlightModel;

    @Prop()
    gaParams: utils.GoogleAnalyticsParams;

    currentFlightDirection: string = '';

    dialogVisible: boolean = false;
        
    NO_BAGGAGE_GUID = '00000000-0000-0000-0000-000000000000';

    customBaggageOptions: [] = [];

    flightDirections: ['Both', 'Outward', 'Return'];
    
    currentPassengerIdByFlightDirection: object = {
        'Outward': 0, 
        'Return': 0,
        'Both': 0
    };

    detectPassengersWithInfant(){
        const infantQuantity = this.reservation.passengers.reduce((a, c) => (c.type == 'infant' ? ++a : a), 0);

        let adultQuantity = 0;
        for(let i=0; infantQuantity > adultQuantity; i++){
            const passenger = this.reservation.passengers[i];
            if (passenger.type == 'adult'){
                this.reservation.passengers[i].seatWithInfant = true;
                adultQuantity++;
            }
        }
    }

    onChangePassenger(id: number, flightDirection: string){
        this.currentPassengerIdByFlightDirection[flightDirection] = id;
    }
    
    onTimesClick(){
        (<any>this).$ga.sendEvent('flights.booking', 'baggage.popap', 'flights.booking.baggage.popap.x', this.gaParams);
        this.closePopup();
    }

    onAddServiceClick(){
        (<any>this).$ga.sendEvent('flights.booking', 'baggage.add', 'flights.booking.baggage.add', this.gaParams);
        this.closePopup();
    }

    openPopup(flightDirection){
        if(flightDirection){
            this.currentFlightDirection = flightDirection;
        }
        (<any>this).$ga.sendEvent('flights.booking', 'baggage.popap', 'flights.booking.baggage.popap', this.gaParams);
        (<any>this).$ga.reachGoal('flights.booking.baggage.popup');
        (<any>this).$refs.modalAdditionalBaggage.show();
    }
    
    closePopup(){
        (<any>this).$refs.modalAdditionalBaggage.hide();
    }

    get hasSelectedCustomOutwardBaggage(): boolean {
        return this.reservation.hasSelectedOutwardCustomBaggage
            || this.reservation.hasSelectedBothCustomBaggage;
    }

    get hasSelectedCustomReturnBaggage(): boolean {
        return this.reservation.hasSelectedReturnCustomBaggage
            || this.reservation.hasSelectedBothCustomBaggage;
    }

    
    getPassengerLabel(index){
        if (this.reservation.passengers[index].firstName
            || this.reservation.passengers[index].middleName
            || this.reservation.passengers[index].lastName) {
            return this.reservation.passengers[index].middleName
                ? `${this.reservation.passengers[index].firstName} ${this.reservation.passengers[index].middleName} ${this.reservation.passengers[index].lastName}`
                : `${this.reservation.passengers[index].firstName} ${this.reservation.passengers[index].lastName}`;
        } else {
            return i18next.t('label_passenger_with_number', { i: index + 1 });
        }
    }

    getCheapestBaggageOptionInFlightDirection(customBaggageOption){
        const result = {
            price: 0,
            weight: 0
        };
        const prices: number[] = [];
        const weights: number[] = [];
        customBaggageOption.baggageOptions.forEach(baggageOption => {
            if (baggageOption.price > 0) {
                weights.push(baggageOption.bagsWeight);
                prices.push(baggageOption.price);
            }
        });

        result.price = Math.min(...prices);
        result.weight = Math.min(...weights);
        
        return result;
    }

    hasPassengersSelectedBaggageOptionsIyFlightDirection(customBaggageOption){
        const passengers = this.reservation.passengers;
        for (let i = 0; i < passengers.length; i++) {
            for (let j = 0; j < passengers[i].baggageOptions.length; j++) {
                for (let ji = 0; ji < customBaggageOption.baggageOptions.length; ji++) {
                    if(customBaggageOption.baggageOptions[ji].id == passengers[i].baggageOptions[j] && passengers[i].baggageOptions[j] !== this.NO_BAGGAGE_GUID){
                        return true;
                    }  
                }
            }       
        }        
    }

    getPassengersWithBaggage(): PassengerModel[] {
        const passengers = this.reservation.passengers;
        const passengersWithBaggage: PassengerModel[] = [];

        for (let i = 0; i < passengers.length; i++) {
            for (let j = 0; j < passengers[i].baggageOptions.length; j++) {
                if(passengers[i].baggageOptions[j] !== this.NO_BAGGAGE_GUID){
                    passengersWithBaggage.push(passengers[i]);
                    break;
                }   
            }
        }
        return passengersWithBaggage;
    }

    getCurrentPassengerByFlightDirection(flightDirection){
        return this.reservation.passengers.find(p=>p.index == this.currentPassengerIdByFlightDirection[flightDirection]);
    }

    getBaggageOptionDirectionLabelById(optionId){
        let label = '';
        this.reservation.selectedFlight?.customBaggage.options?.forEach(option=>{
            return option.baggageOptions.forEach(o=>{
                if(o.id == optionId && o.id !== this.NO_BAGGAGE_GUID){
                    label = option.customBaggageFlightDirection;
                }
            });
        });

        if(label == 'Outward') {
            return i18next.t('label_flight_date_depart');
        }
        if(label == 'Return') {
            return i18next.t('label_flight_date_return');
        }
        if(label == 'Both') {
            return i18next.t('label_flight_search_roundtrip');
        }
    }

    getBaggageOptionById(id){
        let result = {};
        this.reservation.selectedFlight?.customBaggage.options?.forEach(option=>{
            return option?.baggageOptions?.forEach(option=>{
                if(option.id == id){
                    result = option;
                }
            });
        });

        return result;
    }

    getBaggageIndex(selectedOptionId){
        return this.reservation.selectedFlight?.customBaggage.options?.findIndex(option=>{
            return option.baggageOptions.find(option=>{
                return option.id == selectedOptionId;
            });
        });
    }

    selectBaggage(selectedOptionId, flightDirection){
        const passenger = this.getCurrentPassengerByFlightDirection(flightDirection);
        const baggageIndex = this.getBaggageIndex(selectedOptionId);

        (<any>this).$ga.sendEvent('flights.booking', 'baggage.click', 'flights.booking.baggage.click', this.gaParams);
        if(passenger && baggageIndex !== undefined){
            if(passenger.baggageOptions[baggageIndex] == selectedOptionId){
                this.$set(passenger.baggageOptions, `${baggageIndex}`, this.NO_BAGGAGE_GUID);
            } else {
                this.$set(passenger.baggageOptions, `${baggageIndex}`, selectedOptionId);
            }
        }
        this.$emit('baggage-change');
    }

    getDestinationNameById(id) {
        const destination = this.flightBookingDetails.destinations[id];
        let destinationName = '';

        if (destination && destination.city && destination.city.localizedName) {
            destinationName = destination.city.localizedName;
        }

        if (destinationName) {
            return destinationName;
        } else {
            return '';
        }
    }

    get allPassengerHaveSelectedBaggage(): boolean {
        let baggageIndex: number;
        if (this.currentFlightDirection 
            && this.reservation.selectedFlight && this.reservation.selectedFlight.customBaggage
            && this.reservation.selectedFlight.customBaggage.options) {
            this.reservation.selectedFlight.customBaggage.options.forEach((option,index) => {
                if (option.customBaggageFlightDirection == this.currentFlightDirection) {
                    baggageIndex = index;
                }
            });
        }

        const result: boolean = this.reservation.passengers.some(p=>{
            if(p.type !== 'infant'){
                return p.baggageOptions[baggageIndex] !== this.NO_BAGGAGE_GUID;
            }
        });
        
        return result;
    }

    isLegBaggageLabelNeeded(leg: flights.LegModel, legIndex: number) {
        const legHasNotBaggage = leg.baggage && leg.baggage.pieceWeight == 0 && leg.baggage.pieces == 0;
        const legHasAnyBaggage = (leg.baggage && leg.baggage.pieceWeight > 0)
                            || (leg.baggage && leg.baggage.pieces > 0);
        const legBaggageIsUnknown = !leg.baggage;

        return ((legHasNotBaggage || legBaggageIsUnknown) && legIndex == 0 && !this.hasSelectedCustomOutwardBaggage)
            || ((legHasNotBaggage || legBaggageIsUnknown) && legIndex == 1 && !this.hasSelectedCustomReturnBaggage)
            || legHasAnyBaggage;
    }

    getBaggageLabel(segment: flights.SegmentModel, isCabin: boolean): string {
        // For multiFR display baggage from brand group selected flight
        if (this.reservation.hasBrandGroups) {
            this.reservation.brandGroups.forEach((brandGroup) => {
                const f = brandGroup.selectedFlight;

                if (f?.legs[0].segments[0].departureDestination.uniqueId == segment.departureDestination.uniqueId
                    && f?.legs[0].segments[0].arrivalDestination.uniqueId == segment.arrivalDestination.uniqueId) {
                    segment = f?.legs[0].segments[0];
                }
                else {
                    // Check if return leg for CombiIncut
                    if (this.reservation.defaultFlight?.multiFRType == 5) {
                        if (f?.legs[1].segments[0].departureDestination.uniqueId == segment.arrivalDestination.uniqueId
                            && f?.legs[1].segments[0].arrivalDestination.uniqueId == segment.departureDestination.uniqueId) {
                            segment = f?.legs[0].segments[0];
                        }
                    }
                }
            });
        }

        return utils.Baggage.getLabel(isCabin ? segment.baggageCabin : segment.baggage, isCabin);
    }

    hasBaggageCabin(legOrSegment: flights.LegModel | flights.SegmentModel): boolean {
        return legOrSegment.baggageCabin && (legOrSegment.baggageCabin.pieceWeight > 0 || legOrSegment.baggageCabin.pieces > 0);
    }
}